import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { BlendModeQualifier } from "../../qualifiers/blendMode/BlendModeQualifier.js";
import { FlagQualifier } from "../../qualifiers/flag/FlagQualifier.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { createSourceFromModel } from "../../internal/models/createSourceFromModel.js";
import { createPositionFromModel } from "../../internal/models/createPositionFromModel.js";
import { createTimelinePositionFromModel } from "../../internal/models/createTimelinePositionFromModel.js";
import { ACTION_TYPE_TO_BLEND_MODE_MAP } from "../../internal/internalConstants.js";
/**
 * @extends SDK.Action
 * @memberOf SDK
 * @description
 * A generic Layer action that can add a Video, Text or Image layer.<br>
 * This class can represent an overlay or an underlay.
 */

var LayerAction = /*#__PURE__*/function (_Action) {
  _inherits(LayerAction, _Action);

  var _super = _createSuper(LayerAction);

  /**
   * @description Creates a LayerAction to be used with overlays and underlays
   * @param {ImageSource | TextSource | VideoSource} layerSource The Source used for the layer, use the builders provided {@link Qualifiers.Source|here}
   */
  function LayerAction(layerSource) {
    var _this;

    _classCallCheck(this, LayerAction);

    _this = _super.call(this);
    _this.source = layerSource;
    _this._actionModel = {
      actionType: 'overlay',
      source: layerSource.toJson()
    };
    return _this;
  }
  /**
   * @description Sets the layerType to 'u' (underlay) or 'l' (overlay).
   * @param {'u' | 'l'} type
   * @return {this}
   */


  _createClass(LayerAction, [{
    key: "setLayerType",
    value: function setLayerType(type) {
      this.layerType = type;
      this._actionModel.actionType = type === 'u' ? 'underlay' : 'overlay';
      return this;
    }
    /**
     * @description Sets the timeline position of the video layer
     * @param {Qualifiers.TimelinePosition} timelinePosition
     * @return {this}
     */

  }, {
    key: "timeline",
    value: function timeline(timelinePosition) {
      this._timelinePosition = timelinePosition;
      this._actionModel.timelinePosition = timelinePosition.toJson();
      return this;
    }
    /**
     * @description Sets the position of the layer
     * @param {Qualifiers.Position} position
     * @return {this}
     */

  }, {
    key: "position",
    value: function position(_position) {
      this._position = _position;
      this._actionModel.position = _position.toJson();
      return this;
    }
    /**
     * @description Specifies how to blend the image overlay with the base overlay
     * @param {Qualifiers.BlendMode|BlendModeType} blendMode
     * @return {this}
     */

  }, {
    key: "blendMode",
    value: function blendMode(_blendMode) {
      this._blendMode = _blendMode;

      var _$replace$split = "".concat(_blendMode).replace('e_', '').split(":"),
          _$replace$split2 = _slicedToArray(_$replace$split, 2),
          mode = _$replace$split2[0],
          level = _$replace$split2[1];

      if (mode === 'anti_removal') {
        this._actionModel.blendMode = level ? {
          blendModeType: 'antiRemoval',
          level: level
        } : {
          blendModeType: 'antiRemoval'
        };
      } else {
        this._actionModel.blendMode = {
          blendModeType: mode
        };
      }

      return this;
    }
    /**
     * @private
     * @description
     * Closes a layer (layers are built in three stages -> /Open/Transform/Close).
     * @return {SDK.Action}
     */

  }, {
    key: "closeLayer",
    value: function closeLayer() {
      var _a, _b, _c, _d;

      var bit = new Action().addFlag(new FlagQualifier('layer_apply'));
      (_a = this._position) === null || _a === void 0 ? void 0 : _a.qualifiers.forEach(function (qualifier) {
        bit.addQualifier(qualifier);
      }); // Flags are stored separately from qualifiers, we need to add those as well

      (_b = this._position) === null || _b === void 0 ? void 0 : _b.flags.forEach(function (flag) {
        bit.addFlag(flag);
      });

      if (typeof this._blendMode === "string") {
        bit.addQualifier(new Qualifier('e', this._blendMode));
      } else {
        (_c = this._blendMode) === null || _c === void 0 ? void 0 : _c.qualifiers.forEach(function (qualifier) {
          bit.addQualifier(qualifier);
        });
      }

      (_d = this._timelinePosition) === null || _d === void 0 ? void 0 : _d.qualifiers.forEach(function (qualifier) {
        bit.addQualifier(qualifier);
      });
      return bit;
    }
    /**
     * @private
     * @description
     * Opens a layer (layers are built in three stages -> /Open/Transform/Close).
     * @return string
     */

  }, {
    key: "openLayer",
    value: function openLayer() {
      return "".concat(this.source.getOpenSourceString(this.layerType));
    }
    /**
     * @description
     * Serializes the Layer to a string
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return [this.openLayer(), this.source.getTransformation() && this.source.getTransformation().toString(), this.closeLayer()].filter(function (a) {
        return a;
      }).join('/');
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel, transformationFromJson) {
      var source = actionModel.source,
          actionType = actionModel.actionType,
          position = actionModel.position,
          timelinePosition = actionModel.timelinePosition,
          blendMode = actionModel.blendMode;
      var sourceInstance = createSourceFromModel(source, transformationFromJson); // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(sourceInstance);
      var layerType = actionType === 'overlay' ? 'l' : 'u';
      result.setLayerType(layerType);

      if (position) {
        result.position(createPositionFromModel(position));
      }

      if (timelinePosition) {
        result.timeline(createTimelinePositionFromModel(timelinePosition));
      }

      if (blendMode) {
        var blendModeType = ACTION_TYPE_TO_BLEND_MODE_MAP[blendMode.blendModeType] || blendMode.blendModeType;

        if (blendMode === null || blendMode === void 0 ? void 0 : blendMode.level) {
          result.blendMode(new BlendModeQualifier(blendModeType, blendMode.level));
        } else {
          result.blendMode(new BlendModeQualifier(blendModeType));
        }
      }

      return result;
    }
  }]);

  return LayerAction;
}(Action);

export { LayerAction };